import gql from 'graphql-tag'
import { CCItem } from './fragments'

export default gql`
query getCCRouteCategory($categoryId: ID) {
	cashAssist {
		getCCRoute {
			...CCItem
		}
	}
}
${CCItem}`
